import UtilDate from './UtilDate';
import UtilFormats from './UtilFormats';
// import colors from '../styles/Color.scss';
const colors = {
  errorColor: '#cf1322',
  successColor: '#52c41a',
};

const numberFormat1 = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const UtilNumber = {
  formatDouble: (value) => {
    if (isNaN(value)) {
      return '';
    }
    try {
      return UtilFormats.getUserCurrencyFormatWithValueForView(value);

      // return numberFormat1.format(value);
    } catch (error) {}
    return value;
  },
  formatDoubleWithCustomCurrency: (
    value,
    customCurrencySymbol,
    customCurrencyPlacement
  ) => {
    if (isNaN(value)) {
      return '';
    }
    try {
      return UtilFormats.getUserCurrencyFormatWithValueForView(
        value,
        customCurrencySymbol,
        customCurrencyPlacement
      );
    } catch (error) {}
    return value;
  },
  formatDoubleOrginalValue: (value) => {
    if (isNaN(value)) {
      return '';
    }
    try {
      // return UtilFormats.getUserCurrencyFormatWithValueForView(value);

      const formatted = numberFormat1.format(value);
      return formatted.replace(/\.00$/, '');
    } catch (error) {}
    return value;
  },
  getNewUniqID: () => {
    return (
      Math.floor(Math.random() * (99999999999 - 1111111111)) +
      UtilDate.getDateToday().toDate().getTime()
    );
  },
  isNumber: (val) => {
    let str = String(val);
    str = str.trim();
    if (!str) {
      return false;
    }
    str = str.replace(/^0+/, '') || '0';
    let n = Math.floor(Number(str));
    return n !== Infinity && String(n) === str && n >= 0;
  },
  calcTwoNumbersPercentage: (num1, num2) => {
    if (num1 === 0) {
      return 0;
    }
    if (!num1) {
      num1 = 1;
    }
    if (!num2) {
      num2 = 1;
    }
    return Math.round(parseFloat((num1 / num2) * 100));
  },

  calcTwoNumbersPercentageDiff: (num1, num2) => {
    if (!num1) {
      num1 = 1;
    }
    if (!num2) {
      num2 = 1;
    }
    const percentageChange = ((num1 - num2) / Math.abs(num2)) * 100;
    return UtilNumber.formatPercentages(percentageChange);
  },

  // formatPercentages: (val) => {
  //   if (Math.abs(val) >= 1000000) {
  //     return val / 1000000 + 'M';
  //   } else if (Math.abs(val) >= 1000) {
  //     return val / 1000 + 'K';
  //   } else {
  //     return val;
  //   }
  // },

  formatPercentages: (val) => {
    const format = (num) => {
      // Format with max 2 decimals, but remove trailing zeros
      return parseFloat(num.toFixed(2)).toString();
    };

    const abs = Math.abs(val);

    if (abs >= 1_000_000) {
      return format(val / 1_000_000) + 'M';
    } else if (abs >= 1_000) {
      return format(val / 1_000) + 'K';
    }

    return format(val);
  },

  formatAddPlusAtBegining: (percentage) => {
    let isPositive = UtilNumber.getIsPercentagePositive(percentage);
    if (isPositive === 0) {
      return 0 + '%';
    } else if (isPositive) {
      return '+' + percentage + '%';
    } else {
      return percentage + '%';
    }
  },
  getIsPercentagePositive: (percentage) => {
    if (percentage) {
      if (percentage === 0 || percentage === '0') {
        return 0;
      }
      if (
        percentage > 0 ||
        (typeof percentage === 'string' &&
          percentage[0] &&
          percentage[0] !== '-')
      ) {
        return true;
      }
    }
    return false;
  },
  calcLoan: (amount, percentage, months) => {
    if (percentage) {
      percentage = parseFloat(percentage?.toString()?.replaceAll(',', '.'));
    }

    const round = (x) => {
      return Math.round(x * 100) / 100;
    };

    let principal = amount;
    let interest = percentage / 100 / 12;
    let payments = months;

    let x = Math.pow(1 + interest, payments);
    let monthly = (principal * x * interest) / (x - 1);

    if (
      !isNaN(monthly) &&
      monthly !== Number.POSITIVE_INFINITY &&
      monthly !== Number.NEGATIVE_INFINITY
    ) {
      return {
        payment: round(monthly),
        total: round(monthly * payments),
        totalInterest: round(monthly * payments - principal),
      };
    } else {
      return { payment: '', total: '', totalInterest: '' };
    }
  },
  getColorForValue: (value) => {
    if (value < 0) {
      return colors.errorColor;
    } else if (value > 0) {
      return colors.successColor;
    } else {
      return null;
    }
  },
  getCompareColor: (value, otherValue) => {
    if (value && value > otherValue) return colors.successColor;
    if (value && value < otherValue) return colors.errorColor;

    return null;
  },

  getOnlyNumber: (val) => {
    let e = val;
    e = (e && e.toString().replace(/[^\d.+-]/g, '')) || '0';
    if (e.endsWith('-') || (e !== '+' && e.endsWith('+'))) {
      e = e.toString().slice(0, -1);
    }
    return e;
  },
};

export default UtilNumber;
